import React, {useEffect, useMemo, useState} from "react";
import {withRouter} from "react-router-dom";
import {IconButton} from "@mui/material";
import {Delete as DeleteIcon, Edit as EditIcon} from "@mui/icons-material";
import {useFiltered} from "@atttomyx/shared-hooks";
import {useQuery} from "@atttomyx/react-hooks";
import {Cards, ConfirmDeleteDialog, FiltersAccordion, FloatingAddButton} from "@atttomyx/react-components";
import {AccountField} from "../fields";
import {TypeFilters} from "../filters";
import {TypeCard} from "../cards";
import {internalTypeService} from "../../services";
import {sorting} from "@atttomyx/shared-utils";
import {router} from "@atttomyx/react-utils";
import {PAGE_TYPE} from "../../constants";

const TypesPage = (props) => {
    const {
        history, snackbar, dimensions, accounts, accountRenderer, types: allTypes, filters, onDelete
    } = props;

    const [type, setType] = useState(null);
    const [showFilters, setShowFilters] = useState(false);
    const [showDelete, setShowDelete] = useState(false);

    const accountId = filters.options.accountId;

    const types = useMemo(() => {
        return allTypes.filter((type) => type.accountId === accountId);
    }, [allTypes, accountId]);

    const filtered = useFiltered(types, filters, sorting.sortByTitle);
    const query = useQuery();

    useEffect(() => {
        const accountId = query.get("accountId");

        if (accountId) {
            filters.setOptions({
                accountId: accountId,
            });
        }
    }, []);

    return <div className="types-page">
        <div className="field">
            <AccountField
                label="Which types?"
                required={true}
                accounts={accounts}
                accountRenderer={accountRenderer}
                value={accountId}
                onChange={(accountId) => filters.setOptions({
                    accountId: accountId,
                })}
            />
        </div>
        <div className="field">
            <FiltersAccordion
                filters={filters}
                form={TypeFilters}
                open={showFilters}
                onOpen={() => setShowFilters(true)}
                onClose={() => setShowFilters(false)}
            />
        </div>
        <Cards
            items={filtered}
            paging={filters.paging}
            dimensions={dimensions}
            renderer={(type) => <TypeCard key={type.id} type={type} filters={filters}>
                <IconButton
                    color="secondary"
                    title="Delete"
                    className="delete"
                    onClick={() => {
                        setType(type);
                        setShowDelete(true);
                    }}
                >
                    <DeleteIcon/>
                </IconButton>
                <IconButton
                    color="primary"
                    title="Edit"
                    onClick={() => router.redirectTo(history, `${PAGE_TYPE}/${accountId}/${type.id}`)}
                >
                    <EditIcon/>
                </IconButton>
            </TypeCard>}
        />
        <FloatingAddButton
            title="Add type"
            position={!dimensions.landscape || !dimensions.short ? "higher" : undefined}
            center={dimensions.landscape && !dimensions.short}
            onClick={() => router.redirectTo(history, `${PAGE_TYPE}/${accountId}`)}
            disabled={!accountId}
        />
        {showDelete && type ?
            <ConfirmDeleteDialog
                snackbar={snackbar}
                title={type.title}
                onCancel={() => {
                    setShowDelete(false);
                    setType(null);
                }}
                onDelete={(userId) => {
                    setShowDelete(false);
                    setType(null);
                    onDelete(userId);
                }}
                deleter={(success, failure) => internalTypeService.deleteType(type.id, success, failure)}
            /> : null}
    </div>
}

export default withRouter(TypesPage);
